import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-brochure-view',
  templateUrl: './brochure-view.component.html',
  styleUrls: ['./brochure-view.component.css'],
})
export class BrochureViewComponent implements OnInit {
  datas;
  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    this.datas = data;
  }
  ngOnInit(): void {}
}
